import React, { useState } from "react";
import { Container, Row, Col, Alert, Button } from "react-bootstrap";
import WithProducts from "../../HOC/HOCProducts";
import ProductCard from "../Product/ProductCard";
import { GrFormPrevious } from "react-icons/gr";
import { GrFormNext } from "react-icons/gr";

const BestSeller = ({ bestSeller, handleDelete, handleAddToCart, handlePagination, keywords, page, pages }) => {
  const handleFirstPage = (e) => {
    e.preventDefault();
    const updated = { ...keywords, page: 1, limit: keywords.limit };
    handlePagination(updated);
  }

  const handleNext = (e) => {
    e.preventDefault();
    const updated = { ...keywords, page: keywords.page + 1, limit: keywords.limit };
    if (process.env.NODE_ENV === "development") {
      console.log("updated nn", updated);
    }
    handlePagination(updated);

  };

  const handlePrev = (e) => {
    e.preventDefault();
    const updated = { ...keywords, page: keywords.page - 1, limit: keywords.limit };
    if (process.env.NODE_ENV === "development") {
      console.log("updated pp", updated);
    }
    handlePagination(updated);
  };

  if (!Array.isArray(bestSeller) || bestSeller.length === 0) {
    return (
      <Alert variant="info" className="text-center">
        No products available. <br />
        <span className="fw-bold">Check back later or contact support.</span>
      </Alert>
    );
  }

  return (
    <Container>
      <Row>
        <Container>
          <Col lg={12}>
            <h1 className="text-center hover-underline">Best Seller</h1>
          </Col>
        </Container>
      </Row>
      <Row className="row-xs-no-padding">
        {bestSeller && bestSeller.map((product) => (
          <Col key={product._id} lg={3} md={6} sm={6} xs={6} className="mb-3">
            <ProductCard
              product={product}
              handleDelete={handleDelete}
              handleAddToCart={handleAddToCart} />
          </Col>
        ))}
      </Row>
      <Row className="my-3 text-center">
        <Col lg={{ span: 4, offset: 4 }}>
          <div className="d-flex w-100 justify-space-between justify-content-center align-items-center">
            <Button variant="link" onClick={handleFirstPage} > <GrFormPrevious />Page 1</Button>
            <Button variant="outline-primary" onClick={handlePrev} disabled={page === 1}> <GrFormPrevious className="me-2" />Previous</Button>
            <div className="page-info">
              Page {page} of {pages}
            </div>
            {keywords.page < pages && <Button variant="outline-primary" onClick={handleNext} > Next<GrFormNext className="ms-2" /></Button>}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default WithProducts(BestSeller);
